import { Pill, SurfacePagePanel, Table, TBody, TD, TH, THead, TR } from '@/design-system';
import { ProvenanceChip } from '@/versions/v1/shared/ProvenanceChip';
import { planAchievementStatus } from './Performance.transform';
import type { PerformanceViewModel } from './Performance.transform';

export function PlanAchievementPanel({
  plan,
}: {
  plan: NonNullable<PerformanceViewModel['planAchievement']>;
}) {
  const tierLabel = plan.tier === 3 ? 'Tier 3' : 'Tier 2';
  return (
    <SurfacePagePanel
      title={`Plan achievement — ${tierLabel}`}
      subtitle={plan.subtitle}
      meta={plan.columnProvenance ? <ProvenanceChip text={plan.columnProvenance} compact /> : undefined}
    >
      <Table>
        <THead>
          <TR>
            <TH>Period</TH>
            <TH>Actual</TH>
            <TH>Plan</TH>
            <TH>% plan</TH>
          </TR>
        </THead>
        <TBody>
          {plan.rows.map((row) => {
            const tone = planAchievementStatus(row.pctOfPlan);
            const pillTone =
              tone === 'ok' ? 'success' : tone === 'warn' ? 'warning' : 'danger';
            return (
              <TR key={row.period}>
                <TD>
                  <p className="font-medium">{row.period}</p>
                  <p className="text-xs text-muted">{row.periodSubLabel}</p>
                </TD>
                <TD className="tabular">{row.actualTd.toLocaleString()}</TD>
                <TD className="tabular text-[var(--ink-tertiary)]">
                  {row.planTd.toLocaleString()}
                </TD>
                <TD>
                  <span className="inline-flex items-center gap-2">
                    <Pill tone={pillTone}>{row.pctOfPlan.toFixed(1)}%</Pill>
                    {row.provenance ? <ProvenanceChip text={row.provenance} compact /> : null}
                  </span>
                </TD>
              </TR>
            );
          })}
        </TBody>
      </Table>
      {plan.footnote ? <p className="mt-3 text-xs text-muted">{plan.footnote}</p> : null}
    </SurfacePagePanel>
  );
}
